import { useNavigate } from "react-router-dom";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import {
    Box,
    Button,
    MenuItem,
    Select,
    SelectChangeEvent,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
} from "@mui/material";
import React from "react";
import AddIcon from '@mui/icons-material/Add';


const StoreManagement = () => {
    const [storeData, setStoreData] = useState([
        {
            id: 1,
            image: "/static/images/placeholder.png",
            name: "Fashion Haven",
            bio: "Trendy clothing and accessories for modern style.",
            address: "Downtown Dubai, UAE",
            category: "Fashion",
            approval: "Pending",
            btn: "Pending"
        },
        {
            id: 2,
            image: "/static/images/placeholder.png",
            name: "Glow Beauty",
            bio: "Luxury skincare and makeup brand.",
            address: "Marina Mall, Dubai",
            category: "Beauty",
            approval: "Approved",
            btn: "Continue"

        },
        {
            id: 3,
            image: "/static/images/placeholder.png",
            name: "TechVerse",
            bio: "Smart gadgets and latest electronics.",
            address: "Business Bay, Dubai",
            category: "Electronics",
            approval: "Pending",
            btn: "Pending"

        },
        {
            id: 4,
            image: "/static/images/placeholder.png",
            name: "Book Nook",
            bio: "Curated collection of bestsellers and rare finds.",
            address: "Sharjah Central Market",
            category: "Books",
            approval: "Approved",
            btn: "Completed"

        },
    ]);
    const navigate = useNavigate();
    const [valueTabs, setValueTabs] = React.useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };
    const [searchTerm, setSearchTerm] = useState("");

    return (
        <>
            <div className="main_title">
                <h1>Manage Stores</h1>
                <p>
                    <button
                        onClick={() => navigate("/dashboard")}
                        className="btn btn_primary"
                    >
                        Dashboard
                    </button>{" "}
                    - Manage Stores
                </p>
            </div>


            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search..."
                        />
                    </div>
                    <div className="right_s">
                        <Button className="btn btn_primary" onClick={() => navigate('add')}><AddIcon /> Add Store</Button>
                    </div>
                </div>
                <TableContainer className="table_container mt_20">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Sr. No.</TableCell>
                                <TableCell>Store Image</TableCell>
                                <TableCell>Store Name</TableCell>
                                <TableCell>Store Bio</TableCell>
                                <TableCell>Store Address</TableCell>
                                <TableCell>Category</TableCell>
                                <TableCell>Store Approval</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {storeData.length > 0 ? (
                                storeData.map((row, index) => (
                                    <TableRow key={row.id} hover>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>
                                            <div className="user_block">
                                                <figure>
                                                    <img
                                                        src={row.image}
                                                        alt="Store"

                                                    />
                                                </figure>
                                            </div>

                                        </TableCell>
                                        <TableCell>{row.name}</TableCell>
                                        <TableCell>{row.bio}</TableCell>
                                        <TableCell>{row.address}</TableCell>
                                        <TableCell>{row.category}</TableCell>
                                        <TableCell>
                                            {row.approval}
                                        </TableCell>
                                        <TableCell>

                                            <TableCell>
                                                {row.btn === "Pending" && (
                                                    <Button
                                                        variant="outlined"
                                                        color="warning"
                                                        size="small"
                                                        className="btn sm"
                                                        sx={{
                                                            textTransform: "none",
                                                            borderColor: "#f57c00",
                                                            color: "#f57c00",
                                                            fontWeight: 500,
                                                            "&:hover": {
                                                                backgroundColor: "#fff3e0",
                                                                borderColor: "#f57c00",
                                                            },
                                                        }}
                                                    >
                                                        {row.btn}
                                                    </Button>
                                                )}

                                                {row.btn === "Continue" && (
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        size="small"
                                                        className="btn btn_primary sm"
                                                        onClick={() => navigate("/signup-form")}
                                                    >
                                                        {row.btn}
                                                    </Button>
                                                )}

                                                {row.btn === "Completed" && (
                                                    <Button
                                                        variant="contained"
                                                        color="success"
                                                        size="small"
                                                        className="btn sm"

                                                        sx={{
                                                            textTransform: "none",
                                                            fontWeight: 500,
                                                            backgroundColor: "#2e7d32",
                                                            "&:hover": {
                                                                backgroundColor: "#1b5e20",
                                                            },
                                                        }}
                                                    >
                                                        {row.btn}
                                                    </Button>
                                                )}
                                            </TableCell>




                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={8} align="center">
                                        No stores found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </>
    );
};

export default StoreManagement;
